export const CheckboxCheckedSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" {...props}>
        <g id="Checkedbox" transform="translate(-203 -5545)">
            <g id="Rectangle_656" data-name="Rectangle 656" transform="translate(203 5545)" fill="#fff" stroke="#ced4da" strokeWidth="1">
                <rect width="31" height="31" stroke="none" />
                <rect x="0.5" y="0.5" width="30" height="30" fill="none" />
            </g>
            <path id="TICK" d="M0,10.526,3.685,6.88l3.58,3.56L17.815,0,21.5,3.646,7.283,17.75Z" transform="translate(207.75 5551.625)" fill="#191919" />
        </g>
    </svg>
);
